//
export default [
    {
        text: "#",
        value: "id",
    },
    {
        text: "nombre",
        value: "role_name",
    },
    {
        text: "código",
        value: "name",
    },
    {
        text: "fecha de creación",
        value: "created_at",
        format: 'datetime',
        align: 'right',
    },
]